import { jsx } from "react/jsx-runtime";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { validateTidalLicense } from "../../base/index.js";
function ChevronLeft(props) {
  return /* @__PURE__ */ jsx(
    ChevronLeftIcon,
    {
      "data-testid": "ChevronLeft",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ChevronLeft",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
ChevronLeft.tidalIconMeta = {
  categories: "arrows",
  name: "ChevronLeft"
};
validateTidalLicense();
export {
  ChevronLeft
};
//# sourceMappingURL=ChevronLeft.js.map
